function matchesRange(cardNumber, min, max) {
    const checkLength = String(min).length;
    const substr = cardNumber.substr(0, checkLength);
    const intCCNumber = parseInt(substr, 10);

    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);

    return intCCNumber >= min && intCCNumber <= max;
}

function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);

    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}

function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }

    return matchesPattern(cardNumber, pattern);
}

module.exports = matches;
